"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowService = void 0;
var tslib_1 = require("tslib");
var modal_service_1 = require("../components/modal/modal.service");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
/**
 * Manages the native `window` object.
 *
 * Responsibilities include:
 * - mitigating browser incompatibilities
 * - propagating changes with legacy Angular codebase
 */
var WindowService = /** @class */ (function () {
    function WindowService() {
        this.__priority = 0;
        /** Whether navigation is being processed. Used to cancel duplicate navigation events from multiple bindings. */
        this.isNavigating = false;
        /** Whether navigation events have been bound to `window`. Used to ensure navigation events are bound once. */
        this.isStateBound = false;
        /** Navigation callbacks. */
        this.navigationListeners = [];
    }
    WindowService.prototype.setWindow = function (window) {
        this.$window = window;
    };
    Object.defineProperty(WindowService.prototype, "window", {
        get: function () {
            if (this.$window == null) {
                throw new Error('WindowService has not started');
            }
            return this.$window;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WindowService.prototype, "document", {
        get: function () {
            if (this.$window == null) {
                throw new Error('WindowService has not started');
            }
            return this.$window.document;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register a callback to be invoked when navigating to another page.
     *
     * @param msg Confirmation message when confirming navigation.
     * @param stopNavigate Callback which returns true or false to confirm or halt navigation.
     */
    WindowService.prototype.bindNavigateAway = function (msg, stopNavigate) {
        this.ensureWindowEvents();
        this.navigationListeners.push({ msg: msg, stopNavigate: stopNavigate });
    };
    /** De-register navigation callback function */
    WindowService.prototype.unbindNavigateAway = function (stopNavigate) {
        this.navigationListeners = this.navigationListeners.filter(function (listener) { return listener.stopNavigate !== stopNavigate; });
    };
    /** De-register all navigation callback function */
    WindowService.prototype.unbindAllNavigateAway = function () {
        var _this = this;
        this.navigationListeners.forEach(function (l) { return _this.unbindNavigateAway(l.stopNavigate); });
    };
    WindowService.prototype.ensureWindowEvents = function () {
        if (this.isStateBound) {
            return;
        }
        this.$window.addEventListener('beforeunload', this.confirmPageUnload.bind(this));
        this.isStateBound = true;
    };
    WindowService.prototype.confirmPageUnload = function (event) {
        var listener = this.navigationListeners.find(function (l) { return l.stopNavigate(); });
        if (listener == null) {
            // IE11 requires these values to be undefined
            delete event.returnValue;
            return undefined;
        }
        var message = (0, i18n_1.Translate)(listener.msg);
        event.returnValue = message;
        return message;
    };
    WindowService.prototype.confirmPageChange = function (event, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var listener, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        if (this.isNavigating) {
                            return [2 /*return*/, false];
                        }
                        this.isNavigating = true;
                        listener = this.navigationListeners.find(function (l) { return l.stopNavigate(); });
                        result = {
                            ok: true,
                            cancel: false
                        };
                        if (!listener) return [3 /*break*/, 2];
                        modal_service_1.ModalService.close();
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: i18n_1.T.DISCARD_CHANGES_TITLE,
                                content: (0, i18n_1.Translate)(i18n_1.T.DISCARD_CHANGES_CONFIRM),
                                okName: i18n_1.T.DISCARD_CHANGES_DISCARD,
                                hasCancel: true
                            })];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (result.ok) {
                            this.unbindAllNavigateAway();
                            this.isNavigating = false;
                            index_1.Services.Window.$window.open(url, '_top');
                            return [2 /*return*/, true];
                        }
                        this.isNavigating = false;
                        return [2 /*return*/, false];
                }
            });
        });
    };
    return WindowService;
}());
exports.WindowService = WindowService;
//# sourceMappingURL=window.service.js.map